import React, { FC, useContext } from 'react';

import { Link, LinkProps } from '@/helpers/Link/render';

import { LocaleContext } from '@/contexts/locale-context';

/**
 * TYPINGS
 */
export type TranslationType = LinkProps & {
	uri: string;
	language: {
		code: string;
	};
};
export type LangSwitcherProps = {
	translations: Array<TranslationType>;
};

/**
 * COMPONENT
 */
export const LangSwitcher: FC<LangSwitcherProps> = ({ translations }) => {
	const { defaultLocale, locale } = useContext(LocaleContext);

	return (
		<div className="lang-switcher">
			{translations?.map(({ uri, language, ...props }, index) => (
				<Link
					key={index}
					href={uri === '/' ? uri + defaultLocale : uri} // Fix for WordPress => the polylang option Hide URL language information for default language
					className={
						locale === language?.code.toLocaleLowerCase()
							? 'isCurrent'
							: null
					}
					{...props}
				>
					{language?.code}
				</Link>
			))}
		</div>
	);
};

export default LangSwitcher;
